// import axios from "axios";
import { URLS } from "../configuration/urls";
import { isTokenValid } from "../helpers";
import ECAxiosAPI from "../services/API";

export default class ECAuthInterceptor {
  api_url: string;
  keycloack_api_url: string;
  retry_max_times: number;
  retry_time: number;

  constructor() {
    this.api_url = URLS.EC_SPOT_BE();
    this.keycloack_api_url = URLS.EC_AUTH_BE();
    this.retry_max_times = 1;
    this.retry_time = 0;
  }

  initRequestInterceptor = () => {
    ECAxiosAPI.interceptors.request.use(
      async (req: any) => {
        try {
          // const user:any = await Auth.currentSession();
          const token = localStorage.getItem("getToken");
          if (
            token &&
            !req.url.includes("ec-authorization-be/v1/user-manager/login")
          ) {
            req.headers["Authorization"] = `Bearer ${token}`;
          } else {
            throw new Error("NOUSERFOUND");
          }
        } catch (err) {
          // no user
          console.error("No User Found");
        }
        return this.validateRequest(req);
      },
      (err: any) => {
        return Promise.reject(err);
      }
    );
  };

  validateRequest = async (req: any) => {
    const token = localStorage.getItem("getToken");
    switch (token && isTokenValid(token)) {
      case true:
        return req;
      case false:
        const refreshToken = localStorage.getItem("refreshToken");
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "text/plain");

        const requestOptions: any = {
          method: "POST",
          headers: myHeaders,
          body: refreshToken,
          redirect: "follow"
        };
        if (refreshToken && isTokenValid(refreshToken)) {
          const res = await (
            await fetch(
              this.keycloack_api_url + URLS.REFRESHTOKEN,
              requestOptions
            )
          ).json();

          localStorage.setItem("getToken", res?.access_token);
          localStorage.setItem("refreshToken", res?.refresh_token);
          req.headers["Authorization"] = `Bearer ${res?.access_token}`;
          return req;
        } else {
          localStorage.removeItem("getToken");
          localStorage.removeItem("refreshToken");
          if (window.location.hostname !== "localhost") {
            window.location.href = "/";
          }
        }
      default:
        return req;
    }
  };

  initResponseInterCeptor = () => {
    const self = this;
    ECAxiosAPI.interceptors.response.use(
      (res: any) => {
        this.retry_time = 0;
        return res.data;
      },
      (err: any) => {
        if (
          err.request.responseURL.includes(
            "ec-authorization-be/v1/user-manager/login"
          )
        ) {
          return Promise.reject(
            err.response.data.message === "unverified_email"
              ? "UNVERIFIED"
              : "NotAuthorizedException"
          );
        }
        switch (err.response.status) {
          case 401:
            // refresh token
            // return self.getRefreshToken(err.config)
            return Promise.reject(err);
            break;
          default:
            return Promise.reject(err);
        }
      }
    );
  };

  getRefreshToken = async (oldReq: any) => {
    let newToken = "";

    try {
      const refreshToken = localStorage.getItem("refreshToken");
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "text/plain");

      const requestOptions: any = {
        method: "POST",
        headers: myHeaders,
        body: refreshToken,
        redirect: "follow"
      };

      const res = await fetch(
        this.keycloack_api_url + URLS.REFRESHTOKEN,
        requestOptions
      )
        .then((res: any) => {
          localStorage.setItem("getToken", res?.access_token);
          localStorage.setItem("refreshToken", res?.refresh_token);
        })
        .catch((err: any) => {
          throw new Error("request failed");
        });
    } catch (error) {
      // no user
      localStorage.removeItem("getToken");
      localStorage.removeItem("refreshToken");
      // window.location.href = '/'
    }

    if (oldReq && this.retry_time < this.retry_max_times) {
      this.retry_time += 1;
      return ECAxiosAPI.request(oldReq);
    } else {
      if (!newToken) {
        throw new Error("request failed");
      }
      return newToken;
    }
  };
}
